import React, { Component } from 'react'
import { Redirect, useParams } from 'react-router-dom'

const Default = () => {

    function getParameterByName(name, url = document.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return 'none';
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    var url = document.location.href;

    if (url.toLowerCase().includes("logout")) {
        var appName = getParameterByName('appName');
        var redi = "#/logout?appName=" +  appName;
               
        document.location.href = redi;
    }
    else if (url.includes("?") && !url.toLowerCase().includes("logout")) {
       
        var appName = getParameterByName('appName');

        url = url.split("?")[0] + "#/login?appName=" + appName;
        window.location = url;
    }
    else {
        window.location = "?appName=none";
        
    }
    return;
    
};

export default Default;